import PageDefauleTemplate from "../../components/Common/PageDefauleTemplate";
import MonthlyAnalyticsComponent from "../../components/LearningAnalysisPage/MonthlyAnalyticsComponent";

const MonthlyAnalyticsPage = () => {
  return (
    <>
      <PageDefauleTemplate pageName="학습 분석">
        <MonthlyAnalyticsComponent />
      </PageDefauleTemplate>
    </>
  );
};
export default MonthlyAnalyticsPage;
